"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"


export function DisconnectDeliveryIntegrationDialog({
  open,
  integrationName,
  busy,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  integrationName: string
  busy: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) {
  const tUi = useTranslations("Deliveries.DeliveriesDisconnectDeliveryIntegrationDialog")
  const tCommonUi = useTranslations("Common")

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle><span><span key={tUi("disconnect")}>{tUi("disconnect")}</span></span> {integrationName}<span>?</span></AlertDialogTitle>
          <AlertDialogDescription>
            <span key={tUi("agentBindingsWillBeRemovedExistingShipmentAnd")}>{tUi("agentBindingsWillBeRemovedExistingShipmentAnd")}</span></AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}><span key={tCommonUi("cancel")}>{tCommonUi("cancel")}</span></AlertDialogCancel>
          <AlertDialogAction
            onClick={event => {
              event.preventDefault()
              onConfirm()
            }}
            disabled={busy}
          >
            <span key={busy ? tUi("disconnecting") : tUi("disconnect")}>{busy ? tUi("disconnecting") : tUi("disconnect")}</span>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
